export default __webpack_public_path__ + "9eab80c86685aa960e4cd9da24a989bd.svg";